<template>
  <div class="network-management-header__wrapper">
    <div class="network-management-header__content">
      <s-search-input :placeholder="$t('network-management.search-network')" />
      <s-sidebar class="network-management-header__sidebar" ref="sidebar" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NetworkManagementHeader',
  components: {},
  methods: {
    isSidebarVisible() {
      return this.$refs.sidebar?.$data.show ?? false;
    },
  },
};
</script>

<style lang="sass" scoped>
.network-management-header
  &__wrapper
    vertical-align: center
    ::v-deep .material-icons-round
      vertical-align: bottom
  &__content
    display: flex
    padding: 25px 40px 0 40px
    align-items: flex-start
  &__title
    text-transform: uppercase
    width: 100%
    flex-grow: 10
  &__sidebar
    display: flex
    width: 100%
    justify-content: flex-end
  &__badges
    padding: 1rem 2.7rem 0 2.7rem
</style>
